import axios from 'axios';

const publicFetch = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API_CONTEXT
});

export { publicFetch };
